customElements.define('custom-login', class extends HTMLElement {
    constructor() {
        super();

        this.passwordToggle = this.querySelector('.custom-login__form-password-toggle');
        this.passwordInput = this.querySelector('input[type="password"]');
        this.recoverForm = this.querySelector('.custom-recover__form');
        this.loginForm = this.querySelector('.custom-login__form');
        this.recoverFormToggle = this.querySelector('.js-toggle-recover-form');
        this.loginFormToggle = this.querySelector('.js-toggle-login-form');

        this.passwordToggle.addEventListener('click', () => {
            this.passwordInput.type = this.passwordInput.type === 'password' ? 'text' : 'password';
        });

        this.recoverFormToggle.addEventListener('click', () => {
            this.recoverForm.style.display = this.recoverForm.style.display === 'none' ? 'block' : 'none';
            this.loginForm.style.display = this.loginForm.style.display === 'none' ? 'block' : 'none';
        });

        this.loginFormToggle.addEventListener('click', () => {
            this.recoverForm.style.display = this.recoverForm.style.display === 'none' ? 'block' : 'none';
            this.loginForm.style.display = this.loginForm.style.display === 'none' ? 'block' : 'none';
        });
    }
});